export default __webpack_public_path__ + "media/images/rails_logo-7751e453.svg";